import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { SCEmptyState, SCLoader } from 'rollup-allspark';
import { isEmpty } from '../../../utils';
import Message from './Message';
import ToolProgress from './ToolProgress';

const SUGGESTIONS = [
  'How did my sales go last week?',
  'What are my top selling items this month?',
  'Which payment methods do customers use most?',
];

const EmptyState = ({ onSuggestion }) => (
  <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
    <SCEmptyState
      icon={<i className="kt-sparkles text-4xl text-primary" />}
      title="Ask kAI about your business"
      subtitle="kAI answers from your live dashboard data — sales, items, payments and more."
    />
    <div className="mt-4 flex w-full flex-col gap-y-2">
      {SUGGESTIONS.map(s => (
        <button
          key={s}
          type="button"
          onClick={() => onSuggestion(s)}
          className="rounded-lg border border-primary-lighter bg-primary-lightest px-3 py-2 text-left text-sm text-primary-dark hover:bg-primary-lighter"
        >
          {s}
        </button>
      ))}
    </div>
  </div>
);

EmptyState.propTypes = { onSuggestion: PropTypes.func.isRequired };

const MessageList = ({
  messages,
  isStreaming,
  activeTool,
  historyLoading,
  onRetry,
  onSuggestion,
}) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages, activeTool, isStreaming]);

  if (historyLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <SCLoader diameter={28} lineWidth={3} text="Loading conversation…" />
      </div>
    );
  }

  if (isEmpty(messages)) {
    return <EmptyState onSuggestion={onSuggestion} />;
  }

  return (
    <div className="flex flex-1 flex-col gap-y-3 overflow-y-auto px-4 py-4">
      {messages.map(m => (
        <Message key={m.id} message={m} onRetry={onRetry} />
      ))}
      {isStreaming && activeTool ? <ToolProgress name={activeTool.name} /> : null}
      <div ref={bottomRef} />
    </div>
  );
};

MessageList.propTypes = {
  messages: PropTypes.array,
  isStreaming: PropTypes.bool,
  activeTool: PropTypes.object,
  historyLoading: PropTypes.bool,
  onRetry: PropTypes.func,
  onSuggestion: PropTypes.func,
};

export default MessageList;
